<script setup>
import { ref, computed } from 'vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const props = defineProps({
  orgId: {
    type: [String, Number],
    required: true
  },
  open: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:open', 'create'])

const chatName = ref('')

const isOpen = computed({
  get: () => props.open,
  set: (value) => emit('update:open', value)
})

const canCreate = computed(() => {
  return chatName.value.trim() !== ''
})

const handleCreate = () => {
  if (!canCreate.value) return

  emit('create', {
    name: chatName.value.trim()
  })

  // Reset state
  chatName.value = ''
}

const handleCancel = () => {
  chatName.value = ''
  isOpen.value = false
}
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <DialogTitle>Create New Chat</DialogTitle>
        <DialogDescription>
          Create a new AI chat session. You can add layers to analyze after creating the chat.
        </DialogDescription>
      </DialogHeader>

      <div class="space-y-4 py-4">
        <div class="space-y-2">
          <Label for="chat-name">Chat Name</Label>
          <Input
            id="chat-name"
            v-model="chatName"
            type="text"
            placeholder="Enter a name for this chat"
            @keydown.enter="handleCreate"
          />
        </div>
      </div>

      <DialogFooter>
        <Button @click="handleCancel" variant="ghost">Cancel</Button>
        <Button @click="handleCreate" :disabled="!canCreate">Create Chat</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
